import { EmoticonSadOutlineIcon } from './EmoticonSadOutlineIcon';

/**
 * author: Gabriel
 * id 6D8A3A11-7A90-424C-82A6-93C455379743
 * name emoticon-sad-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-sad-outline.svg
 * tags
 * - Emoji 
 */
export const FaceSadOutlineIcon = EmoticonSadOutlineIcon;
export default FaceSadOutlineIcon